import { Button } from "@/components/ui/button";
import { ArrowUpDown } from "lucide-react";

interface CoinControlsProps { showOwned: boolean; onToggleOwned: () => void; sort: "newest" | "volume" | "marketCap"; onSortChange: () => void; }

const CoinControls = ({ showOwned, onToggleOwned, sort, onSortChange }: CoinControlsProps) => {
  return (
    <div className="mb-8">
      <h1 className="text-2xl font-bold mb-2">newly created</h1>
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          <Button variant={showOwned ? "default" : "outline"} size="sm" onClick={onToggleOwned}>
            {showOwned ? "showing owned" : "show owned"}
          </Button>
          <Button variant="outline" size="sm" onClick={onSortChange}>
            {sort === "newest" ? "newest" : sort === "volume" ? "volume" : "market cap"}
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">quick buy</span>
          <Button variant="outline" size="sm">0.01</Button>
        </div>
      </div>
    </div>
  );
};

export default CoinControls;
